import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonFooter from "../../components/footer/CommonFooter";
import EmptyState from "../../components/EmptyState";
import { useSelector } from "react-redux";
import { appApiHandler } from "../../api/appApiHandler";
import "./Order.css";
import OrderCard from "./component/orderCard";
import HomeHeader from "../../components/header/HomeHeader";
import InlineLoader from "../../components/loader/InlineLoader";
import { FaUser, FaShoppingBag } from "react-icons/fa";
import Breadcrumb from "../../components/breadcrumb";

const Orders = () => {
  const navigate = useNavigate();
  const { userData } = useSelector((state) => state.userState);
  const { isLoggedIn } = useSelector((state) => state.authState);

  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);

  const getOrders = async () => {
    try {
      const reqData = {
        user_id: userData?._id,
      };
      const response = await appApiHandler.getOrders(reqData);
      if (response?.status === 200 && response?.data) {
        setOrders(response?.data);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      setLoading(true);
      getOrders();
    }
  }, [isLoggedIn]);

  return (
    <div className="orders-page">
      <HomeHeader />
      <div className="page-content">
      <Breadcrumb
        items={[
          {
            label: "Home",
            path: "/",
          },
          {
            label: "My Order",
            isActive: true,
          },
        ]}
      />
      {!isLoggedIn ? (
        <EmptyState
          icon={FaUser}
          title="Sign In to Continue"
          description="please login with your account. Enjoy a seamless shopping experience with personalized recommendations and more!"
          buttonText="Login"
          onButtonClick={() => navigate("/login")}
          iconSize={48}
        />
      ) : loading ? (
        <div className="orders-container">
          <InlineLoader text="Loading orders..." />
        </div>
      ) : orders.length > 0 ? (
        <div className="orders-container">
          <div className="orders-list">
            {orders.map((order) => (
              <OrderCard key={order?._id} item={order} />
            ))}
          </div>
        </div>
      ) : (
        <EmptyState
          icon={FaShoppingBag}
          title="No orders yet!"
          description="Find something you love and place your first order!"
          buttonText="Browse Products"
          onButtonClick={() => navigate("/")}
          iconSize={48}
        />
      )}
      </div>
      <CommonFooter />
    </div>
  );
};

export default Orders;
